import { Key } from 'react';

const mapPurchasesForDisable = (purchasesIds: Key[]): string[] => {
  const purchasesIdsString = purchasesIds.map((id) => id.toString().split(' ')[0]);
  return purchasesIdsString;
};

export default mapPurchasesForDisable;
